<yzb-form
  #update
  [dict]="dict"
  [curd]="4"
  [loading]="loading"
  (initFormEvent)="onInitForm($event)"
  (getFormDataEvent)="onGetFormData($event)"
  (setFormDataEvent)="onSetFormData($event)"
  [ui]="ui"
>
</yzb-form>
